import { render, staticRenderFns } from "./dialogoApoyo.vue?vue&type=template&id=74187bb2&scoped=true"
import script from "./dialogoApoyo.vue?vue&type=script&lang=js"
export * from "./dialogoApoyo.vue?vue&type=script&lang=js"
import style0 from "./dialogoApoyo.vue?vue&type=style&index=0&id=74187bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74187bb2",
  null
  
)

export default component.exports